export const RETRIEVE_TEMPLATES = (state, payload) => {
  state.templates = payload.data;
}

export const RETRIEVE_SHIPPING_SERVICES = (state, payload) => {
  let { data } = payload;
  let availableServices = data.map(item => item.shipping_services = item.shipping_services.filter(service => service.is_available));

  data.shipping_services = availableServices;
  state.shippingServices = data;
}

export const RETRIEVE_SPREADSHEETS = (state, spreadsheets) => {
  let payload = [];

  spreadsheets.data.forEach(spreadsheet => {
    payload.push(spreadsheet);
  })

  state.spreadsheets = payload;
  state.links = spreadsheets.links;
  state.meta = spreadsheets.meta;
}

export const SET_INFORMATION = (state, payload) => {

  const keys =  Object.keys(payload);

  keys.map(key => {
    state.table_data[key] = payload[key];
  })
}

export const CLEAR_INFORMATION = (state) => {
  state.invalid = true;
  state.table_data = {};
}

export const SET_ACTION = (state, action) => {
  state.action = action;
};

export const ENABLE_LOADING = (state) => {
  state.loading = true;
}

export const DISABLE_LOADING = (state) => {
  state.loading = false;
}

export const ENABLE_MODAL = (state) => {
  state.isModalOpen = true;
}

export const DISABLE_MODAL = (state) => {
  state.isModalOpen = false;
}
